import { Instance, types } from 'mobx-state-tree';

export const ReckoningModel = types.model('ReckoningModel', {
  _id: types.identifier,
  invitation: types.string,
  session: types.string,
  explanationForAnonymousUser: types.maybeNull(types.string),
  inDashboard: types.maybeNull(types.boolean),
  alreadyDone: types.maybeNull(types.boolean),
  onboardingDoneWhenThisReckoningIsDone: types.maybeNull(types.boolean),
  allowAnonymousUser: types.maybeNull(types.boolean),
  allowRegistration: types.maybeNull(types.boolean),
  redirectionPage: types.maybeNull(types.enumeration(['DASHBOARD', 'RECOMMENDED_RESULT'])),
  resultFeature: types.maybeNull(types.string),
  resultRecommendationStrategy: types.maybeNull(types.string),
});

export type IReckoningModel = Instance<typeof ReckoningModel>;

